export default "https://cdn-static.gokick.com/assets/34e3985c60c1a4021cd40bb2eb2cab3e4962f61f/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";